
















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ModalView extends Vue {
  @Prop({ default: "" })
  title!: string;
  @Prop({ default: true })
  exit!: boolean;

  showMe: true;

  created() {
    const escapeHandler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        this.$emit("close");
      }
    };
    document.addEventListener("keydown", escapeHandler);

    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", escapeHandler);
    });
  }
}
